<template>
  <div class="kpi-card">
    <div class="kpi-label" v-html="label"></div>
    <div class="kpi-value">{{ displayValue }}</div>
    <TrendBadge v-if="deltaPct !== null" :pct="deltaPct" label="จากปีก่อน" />
    <div v-else-if="context" class="kpi-context">{{ context }}</div>
  </div>
</template>

<script>
import TrendBadge from "@/components/dashboard/TrendBadge.vue";
import { fmtVal } from "@/utils/nhsoDashboardFormat";

export default {
  name: "KpiCard",
  components: { TrendBadge },
  props: {
    label: { type: String, required: true },
    // Number or the suppression string "<5"; may also be a pre-formatted string.
    value: { type: [Number, String], default: null },
    deltaPct: { type: Number, default: null },
    context: { type: String, default: null },
  },
  computed: {
    displayValue() {
      return fmtVal(this.value);
    },
  },
};
</script>

<style scoped>
.kpi-card {
  background: var(--nd-card);
  border: 1px solid var(--nd-border);
  border-radius: 12px;
  padding: 15px 16px;
  box-shadow: var(--nd-shadow);
  transition: box-shadow 0.18s, transform 0.18s;
}
.kpi-card:hover {
  box-shadow: var(--nd-shadow-hover);
  transform: translateY(-2px);
}
.kpi-label {
  font-size: 12px;
  color: var(--nd-text2);
  line-height: 1.35;
}
.kpi-value {
  font-size: 27px;
  font-weight: 600;
  margin-top: 7px;
  letter-spacing: -0.02em;
  line-height: 1.05;
  font-variant-numeric: tabular-nums;
}
.kpi-context {
  font-size: 11.5px;
  color: var(--nd-muted);
  margin-top: 9px;
}
</style>
